import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedMutation from './AuthorizedMutation';

const GQL = gql`
  mutation acceptInvite($token: String!) {
    acceptInvite(token: $token) {
      farmId
    }
  }
`;

interface AcceptInviteParams {
  token: string;
}

interface Props {
  params: AcceptInviteParams;
  onCompleted: (farmId: string) => void;
  children: (
    execute: () => void,
    loading: boolean
  ) => React.ReactNode;
}

const handleCompleted = (props: Props, data: any) => {
  console.warn(data);
  props.onCompleted(data.acceptInvite.farmId);
};

const AcceptInviteProvider: React.StatelessComponent<Props> = (props: Props) => {
  return (
    <AuthorizedMutation
      mutation={GQL}
      onCompleted={data => handleCompleted(props, data)}
    >
      {(mutateFn, result) =>
        props.children(
          () => mutateFn({ variables: props.params }),
          result.loading
        )
      }
    </AuthorizedMutation>
  );
};

export default AcceptInviteProvider;



// WEBPACK FOOTER //
// ./src/providers/AcceptInviteProvider.tsx